<template>
  <section
    class="class_name"
    v-if='reciveStatus'
  >
    <section >
      <div class="content-con" :style="{width:widthSize+'px'}">
        <!-- 弹出框内题 -->
        <div>{{titleText}}</div>
        <div class="pro_bottom">
          <span class="point" @click="hiddenClick">取消</span>
          <span class="point" @click="saveProduct">确定</span>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
export default {
  /******************************************
  ** 组件名称 popup 弹窗插件
  * @description 组件描述
  * @author zhangwei
  *****************************************
  prop1          <type>            <属性描述>
  isPopupShow    Boolean           弹出窗组件是否显示
  titleText                        弹出窗组件名称
  widthSize                        弹出窗组件宽度
  heightSize                       弹出窗组件高度
  *****************************************/
  name: 'component_name',
  components: {},
  props: {
    isTooltipShow: {
      type: Boolean,
      require: true,
      default: false
    },
    titleText: {
      type: String,
      require: true
    },
    widthSize: {
      type: String,
      require: true,
      default: '51.5'
    }
  },
  data () {
    return {
      reciveStatus: false
    }
  },
  mounted () {},
  computed: {},
  watch: {
    isTooltipShow: function (val) {
      this.reciveStatus = true
      this.disapper()
    }
  },
  methods: {
    // hiddenClick () {
    //   this.$emit('changeTooltipShow')
    // }
    // 弹框3s后定时消失
    disapper () {
      setTimeout(() => {
        this.reciveStatus = false
      }, 3000)
    }

  }
}
</script>
<style lang="less" scoped>

    .content-con {
      // border:solid 0.1rem black;
      border-radius: 1rem;
      background: #fff;
      height: 4rem;
      line-height: 4rem;
      text-align: center;
      position: fixed;
      top: 0;
      left: 42%;
      color:#fff;
      // letter-spacing: 0.05rem;
      background-color: #ffc038;
      .pro_bottom{
      text-align: right;
      font-size:12px;
        span{
          display:inline-block;
          margin-right:10px;
          width:84px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          border: solid 1px #276BEE ;
          border-radius:4px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Tips.vue